<template>
    <div>
      <!-- <keep-alive> -->
          <!-- 需要缓存的视图组件 -->
          <!-- <router-view v-if="$route.meta.keepAlive">
          </router-view>
       </keep-alive> -->
        <!-- 不需要缓存的视图组件 -->
        <router-view >
        </router-view>
    </div>   
</template>

<script>
export default {
  name: 'App',
  //  watch: {//使用watch 监听$router的变化
  //   $route(to, from) {
  //     console.log(from.meta.keepAlive)
  //   }
  // }
}
</script>




// WEBPACK FOOTER //
// src/App.vue